import type { CityConfig } from "../city-template/types";

export const cumberlandConfig: CityConfig = {
  city: "Cumberland",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "cumberland",
  route: "/cumberland",
  title: "Emergency Passport Cumberland, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Cumberland, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Cumberland, Frostburg, LaVale, and Keyser WV residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Cumberland, MD",
  heroSubtitle: "Cumberland travelers — from Allegany County residents to Frostburg State University students to Appalachian Trail hikers — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Western Maryland.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Cumberland%20Maryland%20historic%20downtown%20with%20Victorian%20architecture%2C%20Wills%20Creek%20waterway%2C%20Allegheny%20Mountains%20visible%20in%20background%2C%20charming%20brick%20buildings%2C%20tree-lined%20streets%2C%20warm%20afternoon%20light%2C%20professional%20Appalachian%20mountain%20city%20photography%2C%20no%20visible%20text%20or%20people%2C%20rich%20autumn%20foliage%20and%20rugged%20mountain%20atmosphere&width=1800&height=700&seq=cumberland-md-hero-001&orientation=landscape",
  heroImageAlt: "View of Cumberland Maryland historic downtown with Victorian architecture and the Allegheny Mountains in the background",
  geoPosition: "39.6526;-78.7627",
  geoPlacename: "Cumberland, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 2.5–3 hours from Cumberland via I-68 E and I-70 E",
  },
  nearbyCitiesZips: [
    { name: "Cumberland", zips: "21501, 21502, 21503, 21504, 21505" },
    { name: "Frostburg", zips: "21532" },
    { name: "LaVale", zips: "21502" },
    { name: "Lonaconing", zips: "21539" },
    { name: "Barton", zips: "21521" },
    { name: "Westernport", zips: "21562" },
    { name: "Flintstone", zips: "21530" },
    { name: "Keyser", zips: "26726" },
    { name: "Romney", zips: "26757" },
    { name: "Moorefield", zips: "26836" },
    { name: "Hancock", zips: "21750" },
    { name: "Hagerstown", zips: "21740, 21741, 21742" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Cumberland and Western Maryland departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-2-line", title: "Western Maryland Hub", desc: "Serving Allegany County residents, FSU students, and tri-state area travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no 3-hour trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Hagerstown, MD", route: "/hagerstown" },
    { name: "Emergency passport help in Frederick, MD", route: "/frederick-md" },
    { name: "Urgent passport services in Baltimore, MD", route: "/baltimore" },
    { name: "Maryland passport services overview", route: "/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Cumberland, Maryland remotely via secure registered courier. We do not have a walk-in office in Cumberland — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is especially important for Cumberland residents, as the drive to the nearest passport agency is approximately 2.5–3 hours each way.",
  fpcOfficeAddress: "401 E Pratt St, Baltimore, Maryland 21202",
  fpcOfficeDistance: "Serving Cumberland, Frostburg, LaVale, Lonaconing, and greater Allegany County and Western Maryland",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Cumberland and Allegany County. From historic downtown Cumberland along Baltimore Street to the Frostburg State University campus, from the Allegheny Mountains to the tri-state border with Pennsylvania and West Virginia — we serve all of Western Maryland's diverse communities.",
  nearbyCitiesIntro: "We serve Cumberland and nearby communities including Frostburg, LaVale, Lonaconing, Barton, Westernport, Flintstone, and Keyser WV. We also serve Hancock, Hagerstown, and cross-border West Virginia residents in Keyser, Romney, and Moorefield who prefer our expedited service.",
  howItWorksIntro: "Most Cumberland travelers complete everything online and ship documents overnight. No need to make the 3-hour round trip to downtown DC or navigate Baltimore traffic.",
  mistakesIntro: "Cumberland is a remote Western Maryland hub with a long drive to the nearest passport agency. Here are the most common passport mistakes we see from Cumberland and Allegany County travelers.",
  testimonialsIntro: "Cumberland travelers — from Frostburg State students to mountain community families to tri-state area residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Cumberland, MD? Here are the most common ones we hear from Allegany County and Western Maryland travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Maryland Department of Health Vital Statistics Administration. Online, mail, or in-person at the Baltimore vital records office.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through the Maryland Department of Health Vital Statistics. Required for estate, legal, and survivor benefit matters.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request certified marriage records from the Allegany County Circuit Court Clerk. Required for name change passport applications.", url: "https://www.alleganygov.org/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Allegany County Circuit Court. Required for name change passport corrections.", url: "https://www.alleganygov.org/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for Western Maryland families and students", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive ~3 hours to downtown DC", "Full day commitment — a significant sacrifice for remote residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Cumberland travelers with immediate departure needs — as fast as 24 hours. Critical for Western Maryland residents who cannot afford the 3-hour drive to DC.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "No long drive to DC required"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Cumberland adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Cumberland address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Cumberland residents and families — including Frostburg State University students.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Cumberland residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Cumberland families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Cumberland residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Cumberland MD", description: "Urgent passport processing for Cumberland Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Cumberland MD", description: "Fast passport renewal for Cumberland Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Cumberland MD", description: "New passport application services for Cumberland Maryland residents applying for their first passport." },
    { name: "Child Passport Cumberland MD", description: "Minor passport services for Cumberland Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Patricia H.",
      location: "Cumberland, MD",
      rating: 5,
      text: "Family trip to Canada with 8 days notice. Fast Passport Center processed three passports in 5 days. We didn't have to make the brutal 3-hour drive to DC. Absolute lifesaver for Western Maryland.",
      service: "Family Passport Bundle",
    },
    {
      name: "Ryan F.",
      location: "Frostburg State University",
      rating: 5,
      text: "Study abroad in Ireland with 12 days notice. They caught an issue with my DS-11 form and fixed it before submission. Passport delivered in 48 hours. Saved my semester.",
      service: "Emergency Passport",
    },
    {
      name: "Sharon K.",
      location: "LaVale, MD",
      rating: 5,
      text: "Cruise to Bermuda — realized my passport expired 3 days before departure. Fast Passport Center answered immediately and had a replacement in my hands the next day. Amazing service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Tom B.",
      location: "Keyser, WV",
      rating: 5,
      text: "Even though I'm technically in West Virginia, Cumberland is our nearest city. They served me just like any Maryland resident — professional and fast.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "cumberland-1",
      name: "Cumberland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "35 Baltimore St",
      city: "Cumberland",
      state: "MD",
      zip: "21502",
      phone: "(301) 722-3990",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Cumberland, on Baltimore Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Cumberland acceptance facility. Appointments required — book 1–2 weeks in advance. Accessible off I-68.",
      icon: "ri-mail-line",
    },
    {
      id: "cumberland-2",
      name: "Frostburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 E Main St",
      city: "Frostburg",
      state: "MD",
      zip: "21532",
      phone: "(301) 689-6566",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Frostburg, approximately 10 miles southwest of Cumberland via Route 40",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Frostburg State University students and southwestern Allegany County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "cumberland-3",
      name: "Allegany County Circuit Court",
      type: "County Clerk Passport Acceptance",
      address: "30 Washington St",
      city: "Cumberland",
      state: "MD",
      zip: "21502",
      phone: "(301) 777-5922",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Cumberland, near the historic courthouse",
      website: "https://www.alleganygov.org/",
      websiteLabel: "Allegany County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Best option for first-time applications requiring in-person acceptance.",
      icon: "ri-government-line",
    },
    {
      id: "cumberland-4",
      name: "LaVale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12701 Winchester Rd SW",
      city: "LaVale",
      state: "MD",
      zip: "21502",
      phone: "(301) 729-4445",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "LaVale, approximately 2 miles west of Cumberland on Route 40",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for LaVale and western Cumberland area residents. Ample parking available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — ~3-hour drive each way to DC", fpc: "No — ship from Cumberland" },
    { feature: "Rural Community Support", agency: "No flexibility for remote residents", fpc: "Yes — we specialize in remote area service" },
    { feature: "Frostburg State University", agency: "No student travel coordination", fpc: "Yes — FSU student and academic travel support" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Tri-State Cross-Border Service", agency: "No WV/PA border area support", fpc: "Yes — serve Keyser WV and Somerset PA residents" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Cumberland's remote location means the nearest passport agency is 3 hours away. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip — you can't afford last-minute surprises.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Cumberland sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Cumberland and Allegany County acceptance facilities. Errors mean starting the whole process over.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Cumberland Post Office appointments fill up fast. Book 2–3 weeks ahead — especially in summer when Appalachian Trail and Western Maryland travel is at its peak.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over, which is especially costly when you're 3 hours from the agency.",
    },
    {
      icon: "ri-alert-line",
      title: "Assuming a Last-Minute DC Trip Is Feasible",
      description: "Many Cumberland residents think they can just drive to the DC passport agency in an emergency. With a 3-hour drive each way, this is not practical. Plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Cumberland, Frostburg, or LaVale." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location in Cumberland or along Route 40." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Cumberland address — no 6-hour round trip to DC required." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Cumberland, MD?", a: "Fast Passport Center offers emergency passport processing in Cumberland, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency — without you needing to make the 3-hour drive each way. This is especially valuable for Cumberland and Allegany County residents." },
    { q: "Does Cumberland have its own passport agency?", a: "No — neither Cumberland nor the state of Maryland has a regional passport agency. The nearest facility is the Washington DC Passport Agency, approximately 2.5–3 hours away via I-68 E and I-70 E. Fast Passport Center's courier service is essential for Cumberland residents who cannot afford this 6-hour round trip." },
    { q: "Can I get expedited passport services if I live in Frostburg or LaVale?", a: "Absolutely. Fast Passport Center serves all of the Cumberland area including Frostburg, LaVale, Lonaconing, Barton, and Westernport. We also serve cross-border West Virginia residents in Keyser, Romney, and Moorefield. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Cumberland, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Cumberland travelers use for international flights?", a: "Most Cumberland residents fly internationally through Baltimore-Washington International (BWI), approximately 2 hours east via I-68 E and I-70 E. Washington Dulles (IAD) is approximately 2.5 hours southeast. Pittsburgh International (PIT) is approximately 2.5 hours northwest via I-68 W. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Cumberland?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Cumberland, Frostburg, LaVale, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Cumberland?", a: "The Cumberland Post Office at 35 Baltimore St is the primary downtown acceptance facility. The LaVale Post Office at 12701 Winchester Rd SW serves western Cumberland. The Frostburg Post Office at 10 E Main St serves Frostburg State University students. The Allegany County Circuit Court at 30 Washington St also provides passport acceptance. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks. For Cumberland residents, the courier service is especially important — you simply cannot afford to drive 3 hours to DC at the last minute." },
  ],
  photoLocations: [
    { name: "Walgreens — Cumberland", address: "1270 National Hwy, LaVale, MD 21502", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Cumberland", address: "750 Greene St, Cumberland, MD 21502", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "UPS Store — Cumberland", address: "115 Baltimore St, Cumberland, MD 21502", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–4PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "FedEx — LaVale", address: "12500 National Hwy, LaVale, MD 21502", hours: "Mon–Fri: 8AM–8PM, Sat: 9AM–5PM", website: "https://www.office.fedex.com/default/office" },
  ],
  dmvLocations: [
    { name: "MVA — Cumberland", address: "3 Pershing St, Cumberland, MD 21502", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Allegany County and Western Maryland. REAL ID processing available.", featured: true },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "Approximately 2 hours from Cumberland via I-68 E and I-70 E",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary departure airport for Cumberland travelers. Southwest Airlines hub with direct flights to major US cities and international connections.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "IAD",
      name: "Dulles International",
      distance: "Approximately 2.5 hours from Cumberland via I-68 E and I-270 S",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for international flights and United Airlines hub connections.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
    {
      code: "PIT",
      name: "Pittsburgh International",
      distance: "Approximately 2.5 hours from Cumberland via I-68 W and I-376 W",
      address: "1000 Airport Blvd, Pittsburgh, PA 15231",
      note: "Alternative for western Pennsylvania connections and some international departures.",
      flightUrl: "https://www.flypittsburgh.com/",
      flightLabel: "PIT Flight Info",
      featured: false,
    },
  ],
};